"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";

import {
  Header as HeaderType,
  Megamenu as MegaMenuType,
  User,
  Product,
} from "../../../../payload/payload-types";
import { useRouter } from "next/navigation";
import { useAuth } from "../../../_providers/Auth";
import { CMSLinkMegaMenu } from "../../MegaMenuLink";

import { META } from "../../../_graphql/meta";
import { Media } from "../../../_components/Media";
import classes from "./index.module.scss";
import { useMenu } from "../../../_providers/Menu";
import { FiX } from "react-icons/fi";
import { IoArrowBack } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import { IoSearchOutline } from "react-icons/io5";

export const HeaderNav: React.FC<{
  header: HeaderType;
  megamenu: MegaMenuType;
}> = ({ header, megamenu }) => {
  const navItems = header?.navItems || [];
  const navItemsMegaMenu = megamenu?.navItems || [];
  const { user } = useAuth();
  const { mainMenu, setMainMenu, subMenu, setSubMenu, search, setSearch } =
    useMenu();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const router = useRouter();

  const handleChange = (e) => {
    if (e.target.value.trim() != "" && e.target.value.trim().length >= 3) {
      setSearchValue(e.target.value);
      getResults(e.target.value);
    } else {
      setResults([]);
    }
    setQuery(e.target.value);
  };

  const getResults = async (queryEntries) => {
    const queryT = `query {
            Products(where: {title: { like: "${queryEntries}" } }) {
            docs {
                id
                title
                slug
                ${META}
            }
        }
    }`;

    const docs: Product[] = await fetch(
      `${process.env.NEXT_PUBLIC_SERVER_URL}/api/graphql`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: queryT,
        }),
      }
    )
      ?.then((res) => res.json())
      ?.then((res) => {
        let allProducts = res?.data["Products"]?.docs;
        setResults(allProducts);
        // setLoaded(true);

        if (res.errors)
          throw new Error(res?.errors?.[0]?.message ?? "Error fetching docs");
        return res?.data["Products"]?.docs;
      });
  };

  // console.log("megamenu", megamenu);
  const closeMenu = () => {
    setMainMenu(!mainMenu);
  };

  const closeSearch = () => {
    setSearch(!search);
  };

  const clearSearch = () => {
    setQuery("");
    setResults([]);
  };

  const getAllResults = () => {
      router.push("/search?search=" + searchValue);
  };

  return (
    <>
      <nav
        className={[
          classes.nav,
          // fade the nav in on user load to avoid flash of content and layout shift
          // Vercel also does this in their own website header, see https://vercel.com
          user === undefined && classes.hide,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {navItems?.map(({ link, navBanner }, i) => {
          const linksNavBanner = { ...link, navBanner };
          return (
            <CMSLinkMegaMenu
              key={i}
              {...linksNavBanner}
              children={navItemsMegaMenu}
              appearance="none"
            />
          );
        })}
      </nav>
      <nav
        className={[
          classes.mobileNav,
          // fade the nav in on user load to avoid flash of content and layout shift
          // Vercel also does this in their own website header, see https://vercel.com
          user === undefined && classes.hide,
          mainMenu === true && classes.mobileNavShow,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className={classes.closeMenuBlock} onClick={() => closeMenu()}>
          <FiX size={25} />
        </div>
        <div className={classes.menuBlock}>
          <span className={classes.menuTitle}>MENU</span>
        </div>
        {navItems?.map(({ link, navBanner }, i) => {
          const linksNavBanner = { ...link, navBanner };
          return (
            <CMSLinkMegaMenu
              key={i}
              {...linksNavBanner}
              children={navItemsMegaMenu}
              appearance="none"
            />
          );
        })}
      </nav>

      <div
        className={[
          classes.mobileSearchDiv,
          search === true && classes.mobileSearchDivShow,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className={classes.mobileTopContent}>
          <div className={classes.closeSearchBoxBlock}>
            <div className={classes.closeSearch} onClick={() => closeSearch()}>
              <IoArrowBack size={25} />
            </div>
            <div
              className={classes.searchAttachedIcons}
              onClick={() => getAllResults()}
            >
              <IoSearchOutline size={25} />
            </div>
            <input
              type="text"
              className={classes.inputMobile}
              placeholder="Search for products or brands..."
              value={query}
              onChange={handleChange}
            />
            <div
              className={classes.searchAttachedIcons}
              onClick={() => clearSearch()}
            >
              <IoMdClose size={25} />
            </div>
          </div>
          <ul className={classes.inputBoxResults}>
            {results &&
              results?.map((product, index) => {
                const {
                  meta: { image: metaImage },
                } = product;
                return (
                  <li key={index}>
                    <Link
                      href={
                        `${process.env.NEXT_PUBLIC_SERVER_URL}` +
                        "/products/" +
                        product.slug
                      }
                    >
                      <Media
                        key={index}
                        imgClassName={classes.imageProduct}
                        resource={metaImage}
                      />
                      {product.title}
                    </Link>
                  </li>
                );
              })}
            {results.length > 0 && (
              <Link
                className={classes.allSearchLink}
                href={
                  `${process.env.NEXT_PUBLIC_SERVER_URL}` +
                  "/search?search=" +
                  searchValue
                }
              >
                See all search results
              </Link>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};
